<template>
  <div class="pages-footer">
    <van-button
        type="warning"
        plain
        @click="handleCancel"
    >取消</van-button>
    <van-button
        type="warning"
        :disabled="!twoIds.length"
        @click="handleConfirm"
    >确认配置</van-button>
  </div>
</template>

<script>
import { Button } from "vant";
export default {
    components: {
        [Button.name]: Button
    },
    props: ["twoIds"],
    methods: {
        handleCancel(){
            this.$emit("cancel");
        },
        handleConfirm(){
            this.$emit("confirm");
        }
    }
}
</script>

<style scoped lang="scss">
    .pages-footer {
        height: 54px;
        position: fixed;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 99;
        background-color: #FFF;
        padding: 0 32px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    ::v-deep .van-button {
        min-width: 122px;
        height: 38px;
        border-radius: 4px;
        font-size: 16px;
        border-color: #EC892E;
        &.van-button--warning {
            background-color: #EC892E;
            color: #FFF;
        }
        &.van-button--plain {
            background-color: #FFF;
            color: #EC892E;
        }
    }
</style>